export function initNavigation(): void {
    const pageBody = document.querySelector('body');
    const navContainer = document.querySelector('.navigation');
    const navBtn = document.querySelector('.nav-btn');

    if (!pageBody || !navContainer || !navBtn) {
        return;
    }

    let scrollPosition = 0;

    const xlBreakpoint = window.matchMedia('(min-width: 1200px)');

    const updateNav = () => {
        if (window.scrollY >= 100) {
            navContainer.classList.add('scroll');
        } else {
            navContainer.classList.remove('scroll');
        }
    };

    const openNavigation = () => {
        scrollPosition = window.scrollY;

        navContainer.classList.add('open');

        pageBody.classList.add('block-scrolling');
        pageBody.style.top = `-${scrollPosition}px`;
    };

    const getLockedScrollPosition = (): number => {
        return Math.abs(parseInt(pageBody.style.top || '0', 10)) || scrollPosition;
    };

    const closeNavigation = () => {
        navContainer.classList.add('is-closing');
        navContainer.classList.remove('open');

        window.setTimeout(() => {
            const y = getLockedScrollPosition();

            pageBody.classList.remove('block-scrolling');
            pageBody.style.top = '';

            window.scrollTo(0, y);
            updateNav();

            requestAnimationFrame(() => {
                navContainer.classList.remove('is-closing');
            });
        }, 160);
    };

    const forceCloseNavigation = () => {
        navContainer.classList.remove('open', 'is-closing');

        pageBody.classList.remove('block-scrolling');
        pageBody.style.top = '';

        window.scrollTo(0, scrollPosition);
        updateNav();
    };

    const handleBreakpointChange = (event: MediaQueryListEvent) => {
        if (event.matches) {
            forceCloseNavigation();
        }
    };

    xlBreakpoint.addEventListener('change', handleBreakpointChange);

    navBtn.addEventListener('click', () => {
        if (navContainer.classList.contains('open')) {
            closeNavigation();
        } else {
            openNavigation();
        }
    });

    updateNav();
    window.addEventListener('scroll', updateNav, { passive: true });
}